import styled, { css } from 'styled-components';
import { StatusTone } from 'services/ai_management_possible_competitors';

const tones = {
  success: css`
    border-color: ${(props) => props.theme.$success};
    background: ${(props) => props.theme.$badge_success_fill};
    color: ${(props) => props.theme.$badge_success_text};
  `,
  danger: css`
    border-color: ${(props) => props.theme.$badge_danger_stroke};
    background: ${(props) => props.theme.$badge_danger_fill};
    color: ${(props) => props.theme.$danger};
  `,
  neutral: css`
    border-color: ${(props) => props.theme.$badge_secondary_stroke};
    background: ${(props) => props.theme.$badge_secondary_fill};
    color: ${(props) => props.theme.$gray600};
  `,
  dark: css`
    border-color: ${(props) => props.theme.$gray800};
    background: ${(props) => props.theme.$badge_secondary_fill};
    color: ${(props) => props.theme.$badge_secondary_text};
  `,
  light: css`
    border-color: ${(props) => props.theme.$badge_white_stroke};
    background: ${(props) => props.theme.$badge_white_fill};
    color: ${(props) => props.theme.$badge_white_text};
  `,
};

export const Badge = styled.span<{ $tone: StatusTone }>`
  font-weight: 600;
  border: 1px solid;
  ${(props) => tones[props.$tone]}
`;
